<template>
  <i class="fa fa-fw fa-signal"></i>
</template>

<script>
export default {
  name: 'Ussd',
};
</script>
<style scoped>
.fa {
  color: #2993cf;
}
</style>



// WEBPACK FOOTER //
// UssdIcon.vue?944ae10e